var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#0A6ADA",
    fillOpacity: 0.24,
    rx: 18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#047DEC",
    d: "M18 9.667c-4.592 0-8.334 3.741-8.334 8.333 0 4.592 3.742 8.333 8.333 8.333 4.592 0 8.334-3.741 8.334-8.333 0-4.592-3.742-8.333-8.334-8.333Zm-.626 5a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v4.166a.63.63 0 0 1-.625.625.63.63 0 0 1-.625-.625v-4.166Zm1.392 6.983a.862.862 0 0 1-.175.275.963.963 0 0 1-.275.175.83.83 0 0 1-.317.067.83.83 0 0 1-.316-.067.963.963 0 0 1-.275-.175.86.86 0 0 1-.175-.275.83.83 0 0 1-.067-.317.83.83 0 0 1 .067-.316c.041-.1.1-.192.175-.275a.963.963 0 0 1 .275-.175.834.834 0 0 1 .633 0c.1.041.192.1.275.175a.964.964 0 0 1 .175.275.83.83 0 0 1 .067.316.83.83 0 0 1-.067.317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/info-blue.17c27e020d93888dbe70c3a541a36a47.svg";
export { ForwardRef as ReactComponent };